import React from 'react';
import { __ } from 'i18n/index';

// Placeholders shaped like the match history popup's tabs, summary and set
// rows. Only a few rows: the popup grows to fit the sets that load (the
// AnimatedHeight around it in components/MatchHistory), which looks better
// than shrinking for a player with few sets. Kept out of MatchHistoryPopup so
// the lazy chunk's Suspense fallback can use it.

const SKELETON_SETS = 3;

export function TabSkeletons() {
	return (
		<React.Fragment>
			<span className='history-popup__tab history-popup__tab--skeleton' aria-hidden='true'><span className='history-popup__skeleton' /></span>
			<span className='history-popup__tab history-popup__tab--skeleton' aria-hidden='true'><span className='history-popup__skeleton' /></span>
		</React.Fragment>
	);
}

export function SummarySkeleton() {
	return (
		<div className='history-popup__summary history-popup__summary--skeleton' role='status' aria-label={__('Loading summary')}>
			{[0, 1, 2].map((index) => (
				<div key={index} className='history-popup__stat'>
					<span className='history-popup__skeleton history-popup__skeleton--label' />
					<span className='history-popup__skeleton history-popup__skeleton--value' />
				</div>
			))}
		</div>
	);
}

export function SetSkeletons() {
	return (
		<ul className='history-popup__sets' role='status' aria-label={__('Loading sets')}>
			{Array.from({ length: SKELETON_SETS }, (unused, index) => (
				<li key={index} className='history-popup__set' aria-hidden='true'>
					<span className='history-popup__skeleton history-popup__skeleton--tile' />
					<span className='history-popup__body'>
						<span className='history-popup__skeleton' style={{ width: `${30 + (index * 17) % 30}%` }} />
						<span className='history-popup__skeleton history-popup__detail' style={{ width: `${55 + (index * 13) % 35}%` }} />
					</span>
					<span className='history-popup__skeleton history-popup__when' style={{ width: 72 }} />
				</li>
			))}
		</ul>
	);
}

// The whole popup, while its code loads.
export default function HistoryPopupSkeleton() {
	return (
		<div className='history-popup'>
			<div className='history-popup__tabs'>
				<span className='history-popup__tab is-active'>{__('All')}</span>
				<TabSkeletons />
			</div>
			<SummarySkeleton />
			<SetSkeletons />
		</div>
	);
}
